<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--${vars.backgroundColor})`">
    <div class="container">
      <div v-html="vars.titleHtml" class="tw-mb-10 lg:tw-mb-16"></div>
      <div class="tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row lg:tw-items-center lg:tw-gap-16 xl:tw-gap-32">
        <div class="tw-relative tw-w-full">
          <NuxtImg
            v-if="vars.photoImage"
            :src="vars.photoImage"
            :style="{ borderRadius: 'var(--rounded)', overflow: 'hidden' }"
          />
          <library-iframe v-if="!vars.photoImage && vars.videoUrl" :src="vars.videoUrl" :h-ratio="9" :w-ratio="16" />
        </div>
        <div class="tw-w-full">
          <h3 class="tw-uppercase">{{ vars.titleText }}</h3>
          <div class="tw-mt-5 tw-flex tw-flex-col tw-gap-4 lg:tw-mt-12">
            <p style="color: var(--c-text_tertiary) !important">{{ vars.descriptionText }}</p>
            <div class="tw-mt-4 tw-flex tw-flex-wrap tw-justify-start tw-gap-3">
              <nuxt-link
                v-if="buttons.length > 0"
                v-for="(button, index) in buttons"
                :key="`button-${index}`"
                :class="[buttons.length >= 2 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${button.type}`]"
                :to="button.link"
              >
                {{ button.label }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'LatestPodcast',

  mixins: [ComponentMixin],
  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
